import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid, Stack } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import AppDialog from "../../../components/Common/AppDialog";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import Header from "../../../components/VerticalLayout/Header";
import { getGeneral, getUser, verify_admin } from "../../../store/actions";
import { getPermissionListing } from "../../../store/permission/actions";
import { addNewRole, getRoleDetails, resetRoleState, roleUserAssign, updateRole } from "../../../store/role/action";
import PermissionListing from "./PremissionListing";
import CustomIconButton from "../../../components/Form/CustomIconButton";

const AddRoleAndPermission = ({ type, title, permissionListing, addRole, roleDetails, editRole, userPermission, error, user, roleListing, userList, assign }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ID } = useParams();

  useEffect(() => {
    dispatch(resetRoleState());
    dispatch(getPermissionListing());
    if (type === 'Edit') {
      dispatch(getRoleDetails({ id: ID }));
      initData()
    }

    const handleResize = () => {
      setWidth(window.innerWidth); // Update state when window resizes
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
      dispatch(resetRoleState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loading, setIsLoading] = useState(false);
  const [values, setFormValues] = useState("");
  const [width, setWidth] = useState(window.innerWidth);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [creatable, setCreatable] = useState(true);
  const [editable, setEditable] = useState(true);
  const [length, setLength] = useState("10");
  const [sort, setSorted] = useState("asc");
  const [sort_by, setSortBy] = useState("id");
  const [page, setPage] = useState(1);
  const data = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ]
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [userTempId, setUserTempId] = useState(false)
  const [tempAssignUserArry, setTempAssignUserArry] = useState("")
  // For delete user modal
  const [deleteUserOpen, setDeleteUserOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  // Delete user handler
  const handleDeleteUser = (user) => {
    setUserToDelete(user);
    setDeleteUserOpen(true);
  };

  // Confirm delete user
  const confirmDeleteUser = () => {
    setTempAssignUserArry(prevArr => {
      const prev = Array.isArray(prevArr) ? prevArr : [];
      return prev.filter(u => u.id !== userToDelete.id);
    });
    setDeleteUserOpen(false);
    setUserToDelete(null);
  };

  const initData = () => {
    let payload = {
      length: length || "",
      page: page || "",
      sort: sort || "",
      sort_by: sort_by || "",
      role_id: ID
    }
    dispatch(getUser(payload));
  }

  const header = [
    {
      Header: "# ",
      accessor: (cellProps, idx) => {
        return (idx + 1)
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Name",
      accessor: (cellProps, idx) => {
        return (cellProps?.name || "-")
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Email",
      accessor: (cellProps, idx) => {
        return (cellProps?.email || "-")
      }, disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      accessor: (cellProps) => {
        return (<><Label.StatusByIDLabel label={cellProps?.status} /></>)
      },
      disableFilters: true,
      filterable: false,
    },
  ]

  const actionHeader = [{
    Header: "Department",
    accessor: (cellProps, idx) => {
      return (<div className="">{cellProps?.department || "-"}</div>)
    },
    disableFilters: true,
    filterable: false,
  },]

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-role") && setCreatable(true);
      userPermission?.includes("update-role") && setEditable(true);
      // !userPermission?.includes("view-role") && navigate('/not-authorized');

    }
  }, [userPermission])

  const handleAddUser = () => {
    if (type === "Edit") {
      let payload = {
        id: ID,
        data: {
          staff_id: userTempId
        }
      }
      dispatch(roleUserAssign(payload))
    } else {
      // Add selected users to tempAssignUserArry, preserving existing users and avoiding duplicates
      if (userTempId) {
        const selectedUsers = user.filter(u => userTempId === u?.id);
        setTempAssignUserArry(prevArr => {
          const prev = Array.isArray(prevArr) ? prevArr : [];
          // Avoid duplicates by checking user id
          const newUsers = selectedUsers.filter(su => !prev.some(pu => pu.id === su.id));
          return [...prev, ...newUsers];
        });
      }
      setAddUserOpen(false)
    }
  }

  function updateMenuDataWithPermissions(permissions) {
    if (!Array.isArray(permissionListing.data)) return [];

    // Extract ids from permissions
    const permissionIds = permissions?.length > 0 ? permissions?.map(p => p.id) : [];
    const newMenuData = permissionListing?.data?.length > 0
      ? permissionListing.data?.map((perm) => {
        const allChildIDs = perm.section?.flatMap(sec =>
          sec.permissions?.map(p => p.id)
        );

        // ✅ parent is true if all children are included
        const parentState =
          allChildIDs.length > 0 &&
          allChildIDs.every(id => permissionIds.includes(id));
        return {
          id: perm.id,
          title: perm.module,
          state: parentState, // ✅ parent state depends on all child IDs
          permissionName: perm.module,
          section: perm.section?.map((sec) => ({
            title: sec.section_title,
            state: sec.permissions.every(p => permissionIds.includes(p.id)),
            subMenu: sec.permissions?.map((p, idx) => ({
              id: p.id,
              title: p.title,
              state: permissionIds.includes(p.id) ? true : false, // ✅ submenu state depends on id
              permissionName: p.permissions, // the "name" field
            })),
          })),
        };
      })
      : [];
    setMenuData(newMenuData);
  }

  useEffect(() => {
    if (type === "Edit" && ID && roleDetails) {
      const filtered = roleDetails;

      let payload = {
        display_name: filtered?.display_name || "",
        status: filtered?.status,
        assigned_user: filtered?.staffs?.map((x) => x?.id) || [],
      };

      updateMenuDataWithPermissions(filtered?.permissions);

      setFormValues(payload);
      let data = []
      if (filtered?.default === 1) {
        userList?.data?.length > 0 && userList?.data?.map((x, idx) => {
          data.push({
            id: x?.id,
            name: x?.name,
            email: x?.email,
            status: x?.status,
            department: x?.department_name,
          })
        })
      } else {
        filtered?.staffs?.length > 0 && filtered.staffs?.map((x) => {
          data.push({
            id: x?.id,
            name: x?.name,
            email: x?.email,
            status: x?.status,
            department: x?.department_name,
          })
        })
      }

      setTempAssignUserArry(data);
    }
  }, [roleDetails, permissionListing, type, ID, userList]);


  useEffect(() => {
    getPermissionListing()
  }, [])

  useEffect(() => {
    if (permissionListing?.code === "success" && type === "Add" && Array.isArray(permissionListing.data)) {
      const permissionData = permissionListing.data?.map((mod) => ({
        id: mod?.id,
        title: mod.module,
        state: false,
        section: mod.section?.map((sec) => ({
          title: sec.section_title,
          subMenu: sec.permissions?.map((p, idx) => ({
            id: p.id || `perm-${idx}`,
            title: p.title,
            state: false,
            permissionName: p.permissions, // the "name" field
          })),
        })),
      }));

      setMenuData(permissionData);
    }
  }, [permissionListing]);


  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    if (addRole?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Role added successfully.',
        type: 'success'
      })
      dispatch(getGeneral());
      dispatch(verify_admin());
      navigate('/settings-roles');
    } else if (addRole?.code === "invalid_role") {
      setNotification({
        open: true,
        msg: 'Invalid Role',
        type: 'error'
      })
    } else if (addRole?.code === "validation_failed") {
      setNotification({
        open: true,
        msg: 'Please fill in all required field.',
        type: 'error'
      })
    } else if (addRole?.code === "create_failed") {
      setNotification({
        open: true,
        msg: 'Failed to create.',
        type: 'error'
      })
    }
  }, [addRole])

  useEffect(() => {
    if (editRole?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Role edited successfully.',
        type: 'success'
      })
      dispatch(resetRoleState());
      dispatch(getGeneral());
      dispatch(verify_admin());
      dispatch(getRoleDetails({ id: ID }));
    } else if (editRole?.code === "validation_failed") {
      setNotification({
        open: true,
        msg: 'Please fill in all required field.',
        type: 'error'
      })
    }
  }, [editRole])

  useEffect(() => {
    if (assign?.code === 'success') {
      setNotification({
        open: true,
        msg: 'User assigned successfully.',
        type: 'success'
      })
      dispatch(verify_admin());
      setAddUserOpen(false)
      dispatch(resetRoleState())
      setUserTempId("")
    } else if (assign?.code === "validation_failed") {
      setNotification({
        open: true,
        msg: 'Please select user.',
        type: 'error'
      })
      dispatch(resetRoleState())
    }
  }, [assign])

  function extractPermissionsForSubmission(menuData) {
    const result = {};

    menuData.forEach((module) => {
      (module.section || []).forEach((section) => {
        (section.subMenu || []).forEach((sub) => {
          if (sub.permissionName) {
            result[sub.permissionName] = !!sub.state;
          }
        });
      });
    });

    return result;
  }

  const handleSubmit = (type) => {
    let payload = {
      name: values?.display_name,
      staff_ids: tempAssignUserArry?.length > 0 ? tempAssignUserArry?.map((x) => x?.id) : [],
      // description: values?.description || "-",
      permissions: extractPermissionsForSubmission(menuData),
    }
    if (type === "Edit") {
      dispatch(updateRole({ id: ID, role: payload }))
    } else {
      dispatch(addNewRole(payload))
    }
  }

  return (
    <React.Fragment>
      {
        width <= 425 &&
        <div className="mobile-button-container">
          <Stack direction={"row"} justifyContent={"space-between"} gap={2}>
            <CustomButton
              title={"Cancel"}
              textColor={'#191919'}
              backgroundColor={"transparent"}
              borderStyle={'1px solid #E6E6E6'}
              height={32}
              width={"100%"}
              press={() => { navigate("/settings-roles") }
              }
            />
            <CustomButton
              title={type === "Add" ? "Create" : "Save Changes"}
              press={() => handleSubmit(type)}
              height={32}
              width={"100%"}
            />
          </Stack>
        </div>

      }
      <div className="page-content">
        <LoadingDialog open={loading || (type === "Edit" && !roleDetails)} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Header
            breadcrumb={<Breadcrumbs
              breadcrumbItems={[{ title: "Roles", link: "/settings-roles" },
              { title: title, link: "#" },
              ]}
            >
            </Breadcrumbs>}

            children={
              width >= 425 &&
              < Stack gap={2} direction={{ xs: "column", sm: "row" }} className="d-flex" mb={2}>
                <CustomButton
                  title={"Cancel"}
                  textColor={'#191919'}
                  backgroundColor={"transparent"}
                  borderStyle={'1px solid #E6E6E6'}
                  height={32}
                  press={() => { navigate("/settings-roles") }
                  }
                />
                {
                  creatable &&
                  <CustomButton
                    title={type === "Add" ? "Create" : "Save Changes"}
                    textColor={'white'}
                    height={32}
                    press={() => handleSubmit(type)}
                  />
                }
              </Stack>
            } />
          <div className="setting-header pb-4">{title} </div>
          <Card className="card p-3 px-2 pt-2">
            <CardBody>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={8}>
                  <div className="setting-form-section-header">Basic Information</div>
                  <div className="setting-form-subtitle">Enter the role details below.</div>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                      <CustomTextField
                        title={'Role '}
                        error={error?.name}
                        values={values?.display_name}
                        onChange={(e) => setFormValues((prevValues) => ({
                          ...prevValues,
                          display_name: e
                        }))}
                        placeholder="Enter new role"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardBody>
          </Card>

          <Card className="card p-3 px-2 pt-2">
            <CardBody>
              <div className="setting-form-section-header d-flex justify-content-between">Permissions</div>
              <div className="setting-form-subtitle pb-3">Defines role-based access to system modules.</div>
              <PermissionListing setMenuData={setMenuData} menuData={menuData} />
            </CardBody>
          </Card>
          <Card className="card p-3 px-2 pt-2">
            <CardBody>
              <div className="setting-form-section-header d-flex justify-content-between">
                User Assigned
                <div>
                  {
                    roleDetails?.default !== 1 &&
                    <CustomButton
                      title={"Assign User"}
                      textColor={'white'}
                      backgroundColor={"#A0A0A0"}
                      borderStyle={'1px solid #E6E6E6'}
                      hoverBackgroundColor={'#101010'}
                      hoverColor={'white'}
                      height={36}
                      width={"100%"}
                      press={() => {
                        setAddUserOpen(true);
                        // dispatch(getCustomer({ length: "", page: 0, keyword: "", status: "", sort, sort_by }));

                      }}
                    />
                  }

                </div>
              </div>
              <Table
                header={(() => {
                  const baseHeader = roleDetails?.default === 1 ? header : header.concat(actionHeader);
                  // Add delete action column
                  // Only show Action column if type === 'Add'
                  if (type === 'Add') {
                    return [
                      ...baseHeader,
                      {
                        Header: 'Action',
                        accessor: (cellProps) => (
                          <CustomIconButton
                            iconName={'fluent:delete-32-regular'}
                            onClick={() => handleDeleteUser(cellProps)}
                          />
                        ),
                        disableFilters: true,
                        filterable: false,
                      },
                    ];
                  }
                  return baseHeader;
                })()}
                data={tempAssignUserArry?.slice(
                  (page - 1) * length,
                  page * length
                )}
                pageSize={length}
                totalPage={roleListing?.last_page}
                customToolsBar={true}
                setSorted={setSorted}
                sort_by={sort_by}
                setSortBy={setSortBy}
                sort={sort}
              />
              {/* Delete User Modal */}
              <AppDialog
                open={deleteUserOpen}
                title="Delete assigned user"
                close={() => setDeleteUserOpen(false)}
                positiveTitle="Delete"
                negativeButtonStyle={{ backgroundColor: "white", color: "#191919", border: "1px solid #E6E6E6" }}
                positivePress={confirmDeleteUser}
                negativeTitle={'Cancel'}
                negativePress={() => {setDeleteUserOpen(false)}}
                width={'30%'}
              >
                <div style={{ padding: '10px 0' }}>
                  Are you sure you want to delete <span className="text-bold">{userToDelete?.name ? userToDelete.name : 'this user'}</span> from the assigned list?
                </div>
              </AppDialog>
              <TablePageControl
                from={tempAssignUserArry?.length > 0 ? page == 1 ? 1 : (page - 1) * length + 1 : 0}
                to={
                  tempAssignUserArry?.length > 0
                    ? Math.min(page * length, tempAssignUserArry.length)
                    : 0
                }
                total={tempAssignUserArry?.length}
                length={length}
                setLength={setLength}
                page={page}
                setPage={setPage}
                totalPage={Math.ceil(tempAssignUserArry?.length / length)}
              />
            </CardBody>
          </Card>
        </Container>
        <AppDialog
          open={addUserOpen}
          title="Assign User"
          close={() => {setAddUserOpen(false); setUserTempId("")}}
          positiveTitle="Assign"
          negativeButtonStyle={{ backgroundColor: "white", color: "#191919", border: "1px solid #E6E6E6" }}
          positivePress={() => handleAddUser()}
          negativeTitle={'Close'}
          negativePress={() => { setAddUserOpen(false); setUserTempId("") }}
          width={'40%'}
        >
          <div className="">
            <CustomSelect
              title={'Select User'}
              values={userTempId || []}
              data={tempAssignUserArry?.length > 0 ? user?.filter(
                (x) => !tempAssignUserArry?.some((y) => y?.id === x?.id)
              ) : user || user}
              error={error && error?.staff_id?.[0]}
              placeholder={'Select users'}
              onChange={(e, value) => setUserTempId(e)}
              valueName={"id"}
              labelName={"name"}
              multiple={true}
            />
          </div>

        </AppDialog>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Permission, Role, Login, General, User }) {
  return {
    roleListing: Role.role,
    roleDetails: Role.roleDetails,
    userPermission: Login.permissionArry,
    addRole: Role.addRole,
    editRole: Role.editRole,
    permissionListing: Permission.permissionListing,
    user: General.staff_list,
    error: Role?.error?.errors,
    assign: Role?.roleUserAssign,
    userList: User?.listing
  };
}

export default connect(mapStateToProps)(AddRoleAndPermission);
